export default class LottoStatistics {

    fiveMostRare: number[];
    fiveMostFrequent: number[];
    twoMostFrequent: number[];
    threeMostFrequent: number[];
    twoMostConsecutive: number[];
    threeMostConsecutive: number[];
    singles: Record<number, {appearanceNumber: number, roundsWithoutAppearance: number}>;

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/lotto/LottoStatistics.ts